import firebaseApp from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import { env } from 'env';

const firebase = firebaseApp.initializeApp({
  apiKey: env.REACT_APP_FIREBASE_KEY,
  authDomain: env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: env.REACT_APP_FIREBASE_DATABASE,
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.REACT_APP_FIREBASE_SENDER_ID,
  appId: env.REACT_APP_FIREBASE_APP_ID,
});

export default firebase;
